import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { computed as f, watch as a } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as r } from "../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function n(e) {
  const o = f(e), u = r(o.value);
  return a(o, (t) => {
    u.value = t;
  }), typeof e == "function" ? u : {
    __v_isRef: !0,
    get value() {
      return u.value;
    },
    set value(t) {
      e.set(t);
    }
  };
}
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-memo.js
// module id = 49
// module chunks = 67